// extracted by mini-css-extract-plugin
export var arrow = "_34-6";
export var changeItem = "_34-3";
export var changesHeader = "_34-1";
export var changesList = "_34-2";
export var container = "_34-0";
export var pathLabel = "_34-4";
export var value = "_34-7";
export var valuesContainer = "_34-5";